// extracted by mini-css-extract-plugin
module.exports = {"outer":"-UWj0","headerWrapper":"RHZ8S","heading":"_2Qcr3","blueBoxWrapper":"_2dBQU","leftWrapper":"YcxUU","getBestInterest":"_3z5cL","disclaimer":"DJTFm","email":"_7ZQjj"};